var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 67,
    viewBox: "0 0 70 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 0.0566406C25.6668 0.0566406 19.8332 4.7234 17.5 14.0566C21 9.38988 25.0832 7.63988 29.75 8.80664C32.4125 9.47219 34.3156 11.404 36.4221 13.542C39.8538 17.0254 43.8252 21.0566 52.5 21.0566C61.8332 21.0566 67.6668 16.3899 70 7.05664C66.5 11.7234 62.4168 13.4734 57.75 12.3066C55.0875 11.6411 53.1844 9.70926 51.0779 7.57125C47.6462 4.08793 43.6748 0.0566406 35 0.0566406ZM17.5 21.0566C8.16676 21.0566 2.33324 25.7234 0 35.0566C3.5 30.3899 7.58324 28.6399 12.25 29.8066C14.9125 30.4722 16.8156 32.404 18.9221 34.542C22.3538 38.0254 26.3252 42.0566 35 42.0566C44.3332 42.0566 50.1668 37.3899 52.5 28.0566C49 32.7234 44.9168 34.4734 40.25 33.3066C37.5875 32.6411 35.6844 30.7093 33.5779 28.5712C30.1462 25.0879 26.1748 21.0566 17.5 21.0566Z",
    fill: "url(#paint0_linear_1896_3652)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1896_3652",
    x1: -497.818,
    y1: 2064.44,
    x2: -290.54,
    y2: 4390.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2298BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ED7B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode10);
export default __webpack_public_path__ + "static/media/code10.86f53774b274783e3ada1ccc1c80e17f.svg";
export { ForwardRef as ReactComponent };